// CREATED: Centralized portal root utility to isolate React portals from the main app tree
// All React portals (modals, dropdowns, bottom sheets) must render into #portal-root
// instead of document.body to prevent reconciliation conflicts with browser extensions
// or direct DOM manipulation that could cause "insertBefore" errors.

export function getPortalRoot(): HTMLElement {
  return document.getElementById('portal-root') ?? document.body;
}
